import axios from "axios";
export const insertNoti = async (moduleData) => {
  try {
    const response = await axios.post("http://localhost:8080/webnet-hms/api/notifications/", moduleData);
    window.alert("Notifications inserted successfully:", response.data);
    return response.data;
  } catch (error) {
    window.alert("Error inserting notifications:", error);
  }
};